import { FC } from "react";

import { FormType } from "@simplyk/common";

import { useSalesOpenSchedule } from "../SalesOpeningChip/useSalesOpenSchedule";

import { AuctionCampaignDate } from "./AuctionCampaignDate";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";

export const AuctionDate: FC = () => {
  const { hasDate } = useFormV2Context(FormType.Ticketing);
  const { selectedOccurrenceWithRates, formObject: ticketing } = useFormV2Context(FormType.Ticketing);
  const isDateGhostPreview = useIsGhostPreview("TicketingV2DateSummary");
  const { isSalesScheduled } = useSalesOpenSchedule();

  const endDate = selectedOccurrenceWithRates?.occurrence?.endUtc;

  if (!hasDate || !endDate) {
    return null;
  }

  const opacity = isDateGhostPreview ? GHOST_PREVIEW_OPACITY : isSalesScheduled ? 0.4 : 1;

  return (
    <AuctionCampaignDate
      date={new Date(endDate)}
      timezone={ticketing?.eventTimezone ?? null}
      data-test="auction-date"
      sx={{ opacity }}
    />
  );
};
